<template>
  <Layout class="content-wrapper h-100" :class="'app--'+$route.name.toLowerCase()">
    <Content>
      <router-view> </router-view>
    </Content>
  </Layout>
</template>

<script>
  export default{
    name: 'App',
    data (){
      return{
     }
   },
    methods:{
   }
 }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue